<template>
  <v-dialog
    v-model="dialog"
    centered
    :width="width"
    header-class="border-bottom-0"
    footer-class="border-top-0"
    :persistent="persistent"
  >
    <!--Start Header    ----------------------------------------------------------------------->
    <v-col
      cols="12"
      class="d-flex flex-column justify-content-end align-items-center"
    >
      <span class="d-flex justify-end" v-if="showClose">
        <v-icon
          large
          color="purple darken-0"
          class="font-weight-bold"
          @click="closeModal"
        >
          mdi-close-circle-outline
        </v-icon>
      </span>
      <span class="text-center text-h6">{{ title }} </span>
    </v-col>
    <!--End   Header    ----------------------------------------------------------------------->

    <v-col
      cols="12"
      class="d-flex flex-column justify-content-center align-items-center"
    >
      <slot name="body" />
    </v-col>
    <v-col
      cols="12"
      v-if="$slots['footer']"
      class="d-flex flex-column justify-content-center align-items-center"
    >
      <slot name="footer" />
    </v-col>
  </v-dialog>
</template>
<script>
export default {
  name: "BaseModal",
  props: {
    persistent: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "",
    },
    showClose: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.dialog.dialog;
      },
      set(value) {
        this.$store.commit("dialog/setDialog", value);
      },
    },
  },
  methods: {
    closeModal() {
      this.$store.dispatch("dialog/setDialog", false);
    },
  },
};
</script>
<style>
.v-dialog {
  background-color: white !important;
}
</style>
